<template>
  <i-modal
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="マイソク出力"
    footer-hide
    width="800"
    class="pop-output"
  >
    <div>
      <p style="margin-bottom: 24px;">
        出力したいデザインの「出力する」ボタンを押すことでマイソクが出力されます。
      </p>
      <div class="contents">
        <i-row>
          <i-col span="8" v-for="(item, index) in list" :key="item.id">
            <i-card class="card">
              <div class="card__title">{{ ++index }}.{{ item.name }}</div>
              <div class="card__thumb">
                <img :src="`data:${item.mime};base64,${item.image}`" />
              </div>
              <div style="text-align: center;">
                <i-button type="primary" @click="onClickOutput(item.id, item.f_is_private)">
                  出力する
                </i-button>
              </div>
            </i-card>
          </i-col>
        </i-row>
      </div>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button, Row, Col, Card } from 'view-design'
import ProcessRepository from '@/repositories/processRepository'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-row': Row,
    'i-col': Col,
    'i-card': Card,
  },
  computed: {
    list() {
      return this.$store.getters['ModalMaisoku/getList']
    },
    modal: {
      get() {
        return this.$store.getters['ModalMaisoku/getModal']
      },
      set(val) {
        this.$store.commit('ModalMaisoku/setModal', val)
      },
    },
    select: {
      get() {
        return this.$store.getters['SelectProperty/getProperty']
      },
      set(val) {
        this.$store.commit('SelectProperty/setProperty', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        //
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // 出力ボタン クリック処理
    async onClickOutput(type, f_is_private) {
      this.$store.dispatch('Loading/setLoading', true)
      // const params = {
      //   room_ids: this.select,
      //   type: type,
      // }
      const b_ids = _.map(this.select, item => {
        return item.id
      })
      await ProcessRepository.download(b_ids, type, f_is_private)
        .then(resp => {
          let filename = `maisoku${type}_${this.getFileDate()}.xlsx`

          // Content-Dispositionヘッダーからファイル名を取得
          const contentDisposition = resp.headers['content-disposition'] || resp.headers['Content-Disposition']
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename=([^;]+)/)
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].trim().replace(/['"]/g, '')
            }
          }

          const url = URL.createObjectURL(new Blob([resp.data], { type: 'application/vnd.ms-excel' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          link.parentNode.removeChild(link)
        })
        .catch(e => {
          console.log(e)
          alert('ダウンロードに失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // ファイル名に付与するdate情報を取得する
    getFileDate(_timestamp) {
      let _d = _timestamp ? new Date(_timestamp * 1000) : new Date()

      let Y = _d.getFullYear()
      let m = ('0' + (_d.getMonth() + 1)).slice(-2)
      let d = ('0' + _d.getDate()).slice(-2)
      let H = ('0' + _d.getHours()).slice(-2)
      let i = ('0' + _d.getMinutes()).slice(-2)
      let s = ('0' + _d.getSeconds()).slice(-2)

      return `${Y}${m}${d}${H}${i}${s}`
    },
    // パラメータをリセットする
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.$store.dispatch('ModalPop/reset')
    },
  },
}
</script>

<style lang="scss" scoped>
.pop-output {
  .contents {
    height: 400px;
    overflow: scroll;
  }
  .card {
    &__title {
      font-weight: bold;
    }
    &__thumb {
      width: 100%;
      height: 140px;
      margin-bottom: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 99%;
        max-height: 100%;
        object-fit: contain;
        border: 1px solid #cfcfcf;
      }
    }
  }
}
</style>

<style lang="scss">
.pop-output {
  .ivu-col {
    padding: 0 8px;
  }
  .ivu-card {
    margin-bottom: 24px;
  }
}
</style>
